module.exports = __webpack_public_path__ + "static/media/ogen.973fd913.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ogen.mp4
// module id = 414
// module chunks = 0